import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextInfo, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from '@gc-npm/components.text';
import Image from '@gc-npm/components.c-image';
import Button, { BUTTON_TYPE } from '@gc-npm/components.button';
import {
  actions as modalActions,
} from '@gc-npm/reducers.modals-reducer';
import { TAPON_TYPES } from '@/utils/constants';

import { SCREEN_TYPES } from '@/utils/constants';

const Tapon = ({
  componentContent,
  componentProduct,
  img = TAPON_TYPES.NO_CLIENT.img,
  title = TAPON_TYPES.NO_CLIENT.title,
  description = TAPON_TYPES.NO_CLIENT.description,
  buttonLabel = TAPON_TYPES.NO_CLIENT.description,
  preTitle = '',
}) => {
  const dispatch = useDispatch();

  const main = useSelector(
    (state) => state.main,
  );
  const deviceType = useSelector(
    (state) => state.ui?.deviceType,
  );
  const urlParams = useSelector(
    (state) => state.ui?.urlParams,
  );
  const modalHistory = useSelector(
    (state) => state.modals?.modalHistory,
  );

  const taggingInfo = {
    componentName: 'tapon-mimovistar',
    componentContent,
    componentProduct,
    componentVariation: urlParams && urlParams.Ap_Tcol ? 'area-privada' : 'home-mimovistar',
  };

  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    if (modalHistory && Array.isArray(modalHistory) && modalHistory.length > 0) {
      dispatch(
        modalActions.addModal({
          id: '',
        }),
      );
    }
  }, []);



  return (
    <>
      <div className="tapon container">
        {img && (
          <Image
            src={img}
            layout="intrinsic"
            width={232}
            height={232}
            alt="Movistar"
          />
        )}
        {preTitle && (
          <TextInfo
            text={preTitle}
            color={TEXT_COLOR.MOVISTAR_BLACK}
            size={deviceType === SCREEN_TYPES.MOBILE ? TEXT_SIZE.T4 : TEXT_SIZE.T3}
            fontType={TEXT_FONT_WEIGHT.BOLD}
            align={TEXT_ALIGN.CENTER}
          />
        )}
        {title && (
          <TextInfo
            text={title}
            color={TEXT_COLOR.MOVISTAR_BLACK}
            size={deviceType === SCREEN_TYPES.MOBILE ? TEXT_SIZE.T7 : TEXT_SIZE.T5}
            fontType={TEXT_FONT_WEIGHT.LIGHT}
            align={TEXT_ALIGN.CENTER}
          />
        )}
        {description && (
          <TextInfo
            text={description}
            color={TEXT_COLOR.MOVISTAR_BLACK}
            size={deviceType === SCREEN_TYPES.MOBILE ? TEXT_SIZE.T7 : TEXT_SIZE.T5}
            fontType={TEXT_FONT_WEIGHT.LIGHT}
            align={TEXT_ALIGN.CENTER}
          />
        )}
        {buttonLabel && (
          <Button
            label={buttonLabel}
            href={
                urlParams && urlParams.Ap_Tcol
                  ? 'https://www.movistar.es/cliente/areaprivada/#/misProductos'
                  : 'https://www.movistar.es/particulares/'
                }
            taggingInfo={{ ...taggingInfo, componentContent: 'Volver' }}
            buttonType={BUTTON_TYPE.PRIMARY}
          />
        )}
      </div>
      <style jsx>
        {`
        .tapon {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: justify;
            gap: 2rem;
            max-width: 520px;
            padding-bottom: 36px;
        }
      `}
      </style>
    </>
  );
};

export default Tapon;
